import PortalIdParser from 'PortalIdParser';
import { useSubscribeToCopilotChannel } from 'copilot-toolkit/channel/hooks/useSubscribeToCopilotChannel';
import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
import { useCallback, useState } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import memoizeOne from 'react-utils/memoizeOne';
import { useHostAppName } from './hooks/useHostAppName';

// @ts-expect-error Not Typed
import UIModalIFrame from 'ui-addon-iframeable/host/UIModalIFrame';
import { jsx as _jsx } from "react/jsx-runtime";
const getUrl = memoizeOne(hostAppName => {
  const env = enviro.deployed() ? 'app' : 'local';
  return `${getFullUrl(env)}/chatspot-message-modal-ui/${PortalIdParser.get()}?hostAppName=${hostAppName}&variant=uiiframe`;
});
const CopilotFullscreenModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const hostAppName = useHostAppName();
  const closeModal = useCallback(() => {
    setIsVisible(false);
  }, []);
  const showModal = useCallback(() => {
    setIsVisible(true);
  }, []);
  useSubscribeToCopilotChannel('OPEN_FULLSCREEN_MESSAGE_VIEWER', showModal);
  useSubscribeToCopilotChannel('OPEN_FULLSCREEN_MESSAGE_VIEWER_V2', showModal);
  useSubscribeToCopilotChannel('OPEN_ACTION_FORM', showModal);
  return /*#__PURE__*/_jsx(UIModalIFrame, {
    appName: "chatspot-message-modal-ui",
    height: "600",
    initTimeout: 20000,
    name: "chatspot-message-modal",
    onClose: closeModal,
    onMessage: emptyFunction,
    onReady: emptyFunction,
    preload: true,
    show: isVisible,
    showLoadingIndicator: true,
    src: getUrl(hostAppName),
    width: "1000"
  });
};
export default CopilotFullscreenModal;